export { default as ApplicationSettingLayout } from './ApplicationSettingLayout'
export { default as SimpleLayout } from './SimpleLayout'
export { default as ApplicationLayout } from './ApplicationLayout'
export { default as OnboardingLayout } from 'components/business/Layouts/OnboardingLayout'
